export default __webpack_public_path__ + "static/media/refeicao.53f60cea.png";